//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux'


//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Examples data ------------------
const selector = (state) => state.placement_exam_list;
const placement_exam_distict_assignment_selector = (state) => state.placement_exam_distict_assignment;
const placement_exam_submission_by_examcode = (state) => state.placement_exam_submission_by_examcode;
const placement_exam_session = (state) => state.placement_exam_session;
const placement_exam_org_config = (state) => state.placement_exam_org_config;

//  -- Examples array selector --------

export const usePlacementExamList = () => {
    const selectedData = useSelector(selector, shallowEqual)
    return selectedData;
}

export const usePlacementExamDistrictList = () => {
    const selectedData = useSelector(placement_exam_distict_assignment_selector, shallowEqual)
    return selectedData;
}


export const usePlacementExamSubmissiomByexamcode = () => {
    const selectedData = useSelector(placement_exam_submission_by_examcode, shallowEqual)
    return selectedData;
}
export const usePlacementExamSession = () => {
    const selectedData = useSelector(placement_exam_session, shallowEqual)
    return selectedData;
}

export const usePlacementOrgConfig = () => {
    const selectedData = useSelector(placement_exam_org_config, shallowEqual)
    return selectedData;
}

export const useExamLevelConfig = (active_exam) => {
    const orgConfig = usePlacementOrgConfig()
    const levels = useMemo(() => {
        if(!active_exam) return [];
        const exam_code = active_exam?.assigned?.assignment_code;
        if (orgConfig && orgConfig.levels) {
            return orgConfig.levels[exam_code];
        }
        return [];
    }, [orgConfig, active_exam])
    return levels;
}

export const getLevelsByConfig = (max_marks, exam_levels) => {
    if (Array.isArray(exam_levels) && exam_levels.length > 0) {
        const effectiveMax = max_marks || 32;
        const configTotal = Number(exam_levels[exam_levels.length - 1]?.max) || 32;
        const scale = (n) => Math.round((Number(n) / configTotal) * effectiveMax);
        const mapped = exam_levels.map((l) => ({
            legend: l.title,
            range: [scale(l.min), scale(l.max)],
            color: l.color,
            description: l.description,
            description_english: l.description_english,
        }));
        return mapped;
    }
    const effectiveMax = max_marks || 32;
    const nativos1_end = Math.floor(effectiveMax * 0.2727);
    const nativos2_end = nativos1_end + Math.floor(effectiveMax * 0.3636);
    const nativos3_end = nativos2_end + Math.floor(effectiveMax * 0.2727);
    const ap_end = effectiveMax;
    return [
        { legend: 'Nativos 1', range: [0, nativos1_end] },
        { legend: 'Nativos 2', range: [nativos1_end + 1, nativos2_end] },
        { legend: 'Nativos 3', range: [nativos2_end + 1, nativos3_end] },
        { legend: 'AP Spanish', range: [nativos3_end + 1, ap_end] },
    ];
};